"use strict";
// import React, { useState } from "react";
// import { useScroll } from "../../utils/customHooks/useScroll";
// import { StyledScrollHighlight, StyledScrollHighlightVisible } from "./styled";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageScrollIndicator = void 0;
var react_1 = __importStar(require("react"));
var useScroll_1 = require("../../utils/customHooks/useScroll");
var styled_1 = require("./styled");
/**
 * @component Renders a PageScrollIndicator component to show scroll progress as a highlight line at the top of the page.
 *
 * - The props object contains no properties.
 *
 * @return {ReactElement} The rendered PageScrollIndicator component.
 */
var PageScrollIndicator = function () {
    var _a = (0, react_1.useState)(0), highLightLine = _a[0], setHighLightLine = _a[1];
    var scrollFn = function () {
        var totalDocHeight = document.body.offsetHeight;
        var viewportHeight = window.innerHeight;
        var scrollY = window.scrollY;
        var scrollPercent = scrollY === 0 ? 0 : (scrollY / (totalDocHeight - viewportHeight)) * 100;
        setHighLightLine(scrollPercent);
    };
    (0, useScroll_1.useScroll)(scrollFn);
    return (react_1.default.createElement(styled_1.StyledScrollHighlight, null,
        react_1.default.createElement(styled_1.StyledScrollHighlightVisible, { width: highLightLine })));
};
exports.PageScrollIndicator = PageScrollIndicator;
